module.exports = __webpack_public_path__ + "static/WEDDING E&M-420-bc19827091a8bce41ae8ead788975034.jpg";